import {
    GET_ALL_LOGS_BEGIN, GET_ALL_LOGS_SUCCESS, GET_ALL_LOGS_FAILURE
} from '../constants/ActionTypes'

const initialState = {

    logs: null,
    logsError: null,
    loadingLogs: false,

}

const ReducerLog = (state = initialState, { payload, type }) => {

    switch (type) {

        case GET_ALL_LOGS_BEGIN: {
            return {
                ...state,
                logs: null,
                logsError: null,
                loadingLogs: true
            }
        }

        case GET_ALL_LOGS_SUCCESS: {
            return {
                ...state,
                logs: payload.response,
                logsError: null,
                loadingLogs: false
            }
        }

        case GET_ALL_LOGS_FAILURE: {
            return {
                ...state,
                logs: null,
                logsError: payload,
                loadingLogs: false
            }
        }

        default: return state

    }

}

export default ReducerLog